import { HttpErrorResponse } from "@angular/common/http";
import { Component, ViewChild } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

import { MessageService as PrimeMessageService } from "primeng/api";
import { AdministrationCleanupService } from "@app/services/net-remit/administration.cleanup.service";

import { CleanupInfoView } from "@app/shared/models/administration/cleanup/CleanupInfoView";
import { CustomerCleanupConfigurationInfoView } from "@app/shared/models/administration/cleanup/CustomerCleanupConfigurationInfoView";

import { AutomationCleanupFormComponent } from "@app/administration/cleanup-management/automation-cleanup-management/automation-cleanup-management-form/automation-cleanup-form.component";
import { AutomationCleanupListComponent } from "@app/administration/cleanup-management/automation-cleanup-management/automation-cleanup-management-list/automation-cleanup-list.component";

import { finalize } from "rxjs/internal/operators/finalize";
import { takeWhile } from "rxjs/operators";
import { fadeIn } from 'assets/animations/animations';

@Component({
    selector: 'app-administration-cleanup-management',
    templateUrl: './automation-cleanup-management-layout.component.html',
    styleUrls: ['./automation-cleanup-management-layout.component.scss'],
    animations: [fadeIn],
    standalone: false
})
export class AutomationCleanupManagementLayoutComponent {

  public alive: boolean = true;
  public errorOnLoad: boolean;
  public cleanupInfo: CleanupInfoView;
  public clonedCustomerCleanupConfigurations: Array<CustomerCleanupConfigurationInfoView>;
  private customerListModified: boolean;
  public editing: boolean;
  public isLoading: boolean = true;
  public isLoadingStatusProcess: boolean;
  public isLoadingAirlines: boolean;

  @ViewChild(AutomationCleanupFormComponent) cleanupFormComponent!: AutomationCleanupFormComponent;
  @ViewChild(AutomationCleanupListComponent) cleanupListComponent!: AutomationCleanupListComponent;

  constructor(
    private administrationCleanupService: AdministrationCleanupService,
    private translateService: TranslateService,
    private primeMessageService: PrimeMessageService
  ) {}

  ngOnInit(){
    this.administrationCleanupService.getCleanupData()
      .pipe(finalize(() => { this.isLoading = false }), takeWhile(() => this.alive))
      .subscribe({
        next: (data: CleanupInfoView ) => {
          this.cleanupInfo = data;
          this.clonedCustomerCleanupConfigurations = structuredClone(data.customerCleanupConfigurations);
        }, error: (error:HttpErrorResponse) => {
          this.showToast({ isClosabled: true, severity: "error", summary: "Modal.Error", isSticky: true, detail: error.error });
          this.errorOnLoad = true;
        }, complete: () => {
          this.isLoading = false;
        }
      });
  }

  public saveCleanupProcess(){
    this.isLoading = true;
    this.cleanupInfo.globalCleanupConfigurationInfo.sTimeExecution = this.cleanupInfo.globalCleanupConfigurationInfo.timeExecution.toLocaleTimeString(undefined, { hour12: false });
    this.administrationCleanupService.saveCleanupData(this.cleanupInfo)
      .pipe(finalize(() => { this.isLoading = false }), takeWhile(() => this.alive))
      .subscribe({
        next: (message: string) => {
          this.showToast({ isClosabled: false, severity: "success", summary: "Modal.Success", isSticky: false, detail: message });
          this.cleanupFormComponent.genericCleanupForm?.form.markAsPristine();
          this.updateListModification(false);
        }, error: (error: HttpErrorResponse) => {
          this.showToast({ isClosabled: true, severity: "error", summary: "Modal.Error", isSticky: true, detail: error.error });
        }
      });
  }

  public changeStatusProcess(){
    this.isLoadingStatusProcess = true;
    this.administrationCleanupService.changeStatusProcess(this.cleanupInfo.globalCleanupConfigurationInfo.isProcessEnabled)
      .pipe(takeWhile(() => this.alive))
      .subscribe({
        next: (message: string) => {
          setTimeout(() => {
            this.showToast({ isClosabled: false, severity: "success", summary: "Modal.Success", isSticky: false, detail: message});
            this.isLoadingStatusProcess = false;
          }, 1000)
        }, error: (error: HttpErrorResponse) => {
          this.showToast({ isClosabled: true, severity: "error", summary: "Modal.Error", isSticky: true, detail: error.error});
        }
      });
  }

  public updateIsLoading(value: boolean) {
    this.isLoadingAirlines = value;
  }

  public isEditing(value: boolean) {
    this.editing = value;
  }

  public showToast(data: { isClosabled: boolean; severity: string; summary: string; isSticky: boolean, detail: string }) {
    this.primeMessageService.add({
      closable: data.isClosabled,
      sticky: data.isSticky,
      severity: data.severity,
      summary: this.translateService.instant(data.summary),
      detail: this.translateService.instant(data.detail)
    });
  }

  public updateListModification(value: boolean){
    this.customerListModified = value;
  }

  public checkChangesCustomerList(){
    return !this.customerListModified;
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.alive = false;
  }
}
